import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

const SECTION_TITLE_VARIANTS = {
    default: {
        icon: "",
        label: "",
    },
    highlight: {
        icon: "text-primary-dark",
        label: "text-primary-dark",
    },
} as const;

export type SectionTitleVariant = keyof typeof SECTION_TITLE_VARIANTS;

interface SectionTitleProps {
    label: string;
    icon: string | ReactNode;
    variant?: SectionTitleVariant;
    iconSize?: "small" | "medium";
}

const SectionTitle = ({
    label,
    icon,
    variant = "default",
    iconSize = "small",
}: SectionTitleProps) => {
    const styles = SECTION_TITLE_VARIANTS[variant];

    return (
        <div className="flex flex-row items-center gap-1">
            {typeof icon === "string" ? (
                <img
                    alt=""
                    className={cn(
                        iconSize === "small" ? "h-4 w-4" : "h-6 w-6",
                        styles.icon,
                    )}
                    src={icon}
                />
            ) : (
                <span
                    className={cn(
                        "flex h-4 w-4 shrink-0 items-center justify-center [&_svg]:h-4 [&_svg]:w-4",
                        styles.icon,
                    )}
                >
                    {icon}
                </span>
            )}
            <h2
                className={cn(
                    "text-[10px] font-medium uppercase text-text-caption",
                    styles.label,
                )}
            >
                {label}
            </h2>
        </div>
    );
};

export default SectionTitle;
